(function () {
  if (window.__editorialMotion) return;
  window.__editorialMotion = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('editorial-motion');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  function observeAll(root) {
    (root || document).querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (el) {
      if (window.Shopify && window.Shopify.designMode) {
        el.classList.add('is-revealed');
      } else {
        observer.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeAll();
    });
  } else {
    observeAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    observeAll(event.target);
  });
})();

(function () {
  // Editorial videos autoplay muted on a loop; this just nudges browsers that don't start them.
  var videos = document.querySelectorAll('video[data-editorial-video]');
  videos.forEach(function (video) {
    video.muted = true;
    video.loop = true;
    var attempt = video.play();
    if (attempt && attempt.catch) attempt.catch(function () {});
  });
})();
